export const LOAD_USERS = 'LOAD_USERS';
export const LOAD_USERS_GROUPS = 'LOAD_USERS_GROUPS';
export const LOAD_USERS_GROUPS_FOR_USERS = 'LOAD_USERS_GROUPS_FOR_USERS';
export const LOAD_RESELLERS = 'LOAD_RESELLERS';
export const LOAD_PERMISSION_GROUP = 'LOAD_PERMISSION_GROUP';
export const SET_USER_PAGINATION = 'SET_USER_PAGINATION';
export const SET_USER_SORT = 'SET_USER_SORT';
export const SET_DISABLE_USER = 'SET_DISABLE_USER';
export const SET_RESELLER_FILTER = 'SET_RESELLER_FILTER';
export const SET_USER_NAME_FILTER = 'SET_USER_NAME_FILTER';
export const SET_PERMISSION_NAME_FILTER = 'SET_PERMISSION_NAME_FILTER';
export const SET_USER_STATUS_FILTER = 'SET_USER_STATUS_FILTER';
export const LOAD_USERS_GROUPS_FROM_USER = 'LOAD_USERS_GROUPS_FROM_USER';
export const SET_USER_GROUPE_FILTER = 'SET_USER_GROUPE_FILTER';
export const SET_PERMISSION_GROUP_FILTER = 'SET_PERMISSION_GROUP_FILTER';
export const SET_EMPTY_EDITABLE_USER = 'SET_EMPTY_EDITABLE_USER';
export const RESET_FILTER_USERS = 'RESET_FILTER_USERS';
export const RESET_FILTER_USERS_GROUPS = 'RESET_FILTER_USERS_GROUPS';
export const ADD_NEW_USER = 'ADD_NEW_USER';
export const LOAD_EDITTABLE_USER = 'LOAD_EDITTABLE_USER';
export const SET_EMPTY_EDITTABLE_USER = 'SET_EMPTY_EDITTABLE_USER';
export const EDIT_USER = 'EDIT_USER';
export const ADD_NEW_USER_GROUP = 'ADD_NEW_USER_GROUP';
export const LOAD_EDITTABLE_USER_GROUP = 'LOAD_EDITTABLE_USER_GROUP';
export const SET_EMPTY_EDITTABLE_USER_GROUP = 'SET_EMPTY_EDITTABLE_USER_GROUP';
export const SELECT_PERMISSIONS_GROUPS = 'SELECT_PERMISSIONS_GROUPS';
export const EDIT_USER_GROUP = 'EDIT_USER_GROUP';
